"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.distanceFrom = distanceFrom;
function distanceFrom(refPoint, checkPoint) {
    return Math.max(Math.abs(refPoint.x - checkPoint.x), Math.abs(refPoint.y - checkPoint.y));
}
